import React from "react";
import { Link } from "react-router-dom";
import { trackWhatsAppContact, trackPhoneContact } from "../helper/facebookPixel";

const SubscribeOne = () => {
  return (
    <div className="container">
      <div
        className="footer-top-1 bg-theme"
        style={{ backgroundImage: "url(assets/img/bg/footer-top-bg1-1.png)" }}
      >
        <div className="footer-logo">
          <Link to="/">
            <img src="/assets/img/logo-white.svg" alt="LealChapaYPintura" />
          </Link>
        </div>
        <div className="call-media-wrap">
          <div className="icon">
            <img src="/assets/img/icon/phone-1.svg" alt="LealChapaYPintura" />
          </div>
          <div className="media-body">
            <h6 className="title text-white">Llámanos</h6>
            <h4 className="link">
              <a className="text-white" href="tel:+34698925394" onClick={trackPhoneContact} target="_blank" rel="noopener noreferrer">
                (+34) 698 925 394
              </a>
            </h4>
          </div>
        </div>
        <div className="social-btn">
          <a href="https://www.facebook.com/people/Leal-chapa-y-pintura/100063494171024" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-f" />
          </a>
          <a href="https://wa.me/+34698925394" onClick={trackWhatsAppContact} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp" />
          </a>
          <a href="https://instagram.com/lealchapaypintura" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscribeOne;
